"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var RangePicker = _lib.DatePicker.RangePicker;
function ArcDate(props) {
  var dateFormatList = ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm'];
  var placeholder = props.placeholder,
    isRange = props.isRange,
    placement = props.placement,
    status = props.status,
    onChange = props.onChange,
    value = props.value,
    onOk = props.onOk,
    picker = props.picker,
    className = props.className,
    allowClear = props.allowClear,
    disabled = props.disabled,
    disabledDate = props.disabledDate,
    showTime = props.showTime,
    dropdownClassName = props.dropdownClassName,
    locale = props.locale,
    startDate = props.startDate,
    endDate = props.endDate,
    format = props.format,
    suffixIcon = props.suffixIcon;
  var dateValue = value ? (0, _moment["default"])(value) : (0, _moment["default"])();
  return !isRange ? /*#__PURE__*/_react["default"].createElement(_lib.DatePicker, {
    defaultValue: dateValue,
    placeholder: placeholder,
    style: {
      width: '100%'
    },
    placement: placement,
    format: showTime ? dateFormatList[1] : dateFormatList[0],
    showTime: showTime,
    onChange: onChange,
    value: dateValue,
    onOk: onOk,
    picker: picker,
    status: status,
    className: className,
    allowClear: allowClear ? allowClear : false,
    disabled: disabled ? disabled : false,
    disabledDate: disabledDate ? disabledDate : false,
    dropdownClassName: dropdownClassName ? dropdownClassName : '',
    locale: locale
  }) : /*#__PURE__*/_react["default"].createElement(RangePicker, {
    onChange: onChange,
    showTime: showTime,
    format: format,
    defaultValue: startDate && endDate ? [(0, _moment["default"])(startDate), (0, _moment["default"])(endDate)] : '',
    disabled: disabled ? disabled : false,
    disabledDate: disabledDate ? disabledDate : false,
    suffixIcon: suffixIcon
  });
}
var _default = ArcDate;
exports["default"] = _default;